import { openBlock as A, createElementBlock as t, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(l, e) {
  return A(), t("svg", o, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M6 19a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 18v-3a.97.97 0 0 1 .287-.713A.97.97 0 0 1 6 14a.97.97 0 0 1 .713.287A.97.97 0 0 1 7 15v2h2q.425 0 .713.288A.97.97 0 0 1 10 18q0 .424-.287.712A.97.97 0 0 1 9 19zm0-9a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 9V6a.97.97 0 0 1 .287-.713A.97.97 0 0 1 6 5h3a.97.97 0 0 1 .713.287A.97.97 0 0 1 10 6a.97.97 0 0 1-.287.713A.97.97 0 0 1 9 7H7v2q0 .424-.287.712A.97.97 0 0 1 6 10m9 9a.97.97 0 0 1-.712-.288A.97.97 0 0 1 14 18q0-.424.288-.712A.97.97 0 0 1 15 17h2v-2q0-.425.288-.713A.97.97 0 0 1 18 14q.424 0 .712.287.288.288.288.713v3q0 .424-.288.712A.97.97 0 0 1 18 19zm3-9a.97.97 0 0 1-.712-.288A.97.97 0 0 1 17 9V7h-2a.97.97 0 0 1-.712-.287A.97.97 0 0 1 14 6q0-.425.288-.713A.97.97 0 0 1 15 5h3q.424 0 .712.287Q19 5.575 19 6v3q0 .424-.288.712A.97.97 0 0 1 18 10"
    }, null, -1)
  ])]);
}
const q = { render: r };
export {
  q as default,
  r as render
};
